const DEBOUNCE_SEARCH = 'DEBOUNCE_SEARCH';
const DEBOUNCE_SEARCH_FULFILLED = 'DEBOUNCE_SEARCH_FULFILLED';

export { DEBOUNCE_SEARCH, DEBOUNCE_SEARCH_FULFILLED };
